import { formatPrecisaoFloat } from "../../../utils";
import { parcelaData } from "../../nf-saida/add-nf-saida/add-nf-saida";
import { getAtrasoDias } from "../add-contas-receber/add-contas-receber";

export const montaListaRenegociacoes = (
  listaContasReceber,
  renegociacaoTitulos,
  meioPagamento,
  condicaoPagamento,
  totalAReceber,
  insertUserId,
) => {
  const titulosPagadores = listaContasReceber.reduce(
    (acc, currentItem) => {
      acc[0].push(currentItem?.numeroTitulo);
      acc[1].push(currentItem?.pagadorId);
      acc[2].push(currentItem?.id);
      return acc;
    },
    [[], [], []],
  );
  const bodyMask = {
    status: "ABERTO",
    origem: "RENEGOCIAÇÃO",
    bancoCaixaId: meioPagamento?.bancoCaixaId,
    dataLancamento: new Date().toISOString(),
    meioPagamento,
    meioPagamentoId: meioPagamento.id,
    pagamentos: [],
    observacaoList: [
      {
        observacao: `DUPLICATA PROVENIENTE DE RENEGOCIAÇÃO: ${titulosPagadores[0]}`,
        createdAt: new Date().toISOString(),
        insertUserId,
      },
    ],
    pago: false,
  };
  const listaRenegociacoesTemp = [];
  for (let i = 0; i < renegociacaoTitulos.quantidadeParcelas; i++) {
    const valor =
      totalAReceber.receber / renegociacaoTitulos.quantidadeParcelas;
    const valorFormatado = formatPrecisaoFloat(valor);
    const restoDivisao =
      totalAReceber.receber -
      valorFormatado * renegociacaoTitulos.quantidadeParcelas;
    const calculoValorConta =
      i === renegociacaoTitulos.quantidadeParcelas - 1
        ? formatPrecisaoFloat(valorFormatado + restoDivisao)
        : valorFormatado;
    const body = {
      ...bodyMask,
      dataVencimento: parcelaData(
        i,
        renegociacaoTitulos.dataVencimento,
        condicaoPagamento?.periodo,
      ),
      contasId: titulosPagadores[2],
      valor: calculoValorConta,
      valorTotal: calculoValorConta,
      saldoReceber: calculoValorConta,
    };
    listaRenegociacoesTemp.push(body);
  }
  return {
    pagadores: titulosPagadores[1],
    lista: listaRenegociacoesTemp,
  };
};

export function jurosMultaDoTitulo(jurosMultaEmpresas, contaReceber) {
  const jurosMultaEmpresa = jurosMultaEmpresas.find(
    (item) => item.empresaId == contaReceber?.empresaId,
  );
  return {
    jurosPorcentagem: jurosMultaEmpresa?.jurosPorcentagem
      ? jurosMultaEmpresa.jurosPorcentagem / 100
      : null,
    multaPorcentagem: jurosMultaEmpresa?.multaPorcentagem
      ? jurosMultaEmpresa.multaPorcentagem / 100
      : null,
    carencia: jurosMultaEmpresa?.carencia ?? 0,
  };
}

export function calculaMultaJurosBaixa(
  contaReceber,
  renegociacaoTitulos,
  dataPagamento = new Date(),
) {
  let [multa, juros, subtotal] = [0, 0, 0];
  const atraso = getAtrasoDias(contaReceber?.dataVencimento, dataPagamento);
  subtotal = contaReceber?.saldoReceber ?? 0;
  if (atraso <= renegociacaoTitulos?.carencia) {
    return subtotal;
  }
  multa =
    atraso > 0 && renegociacaoTitulos?.multaPorcentagem
      ? formatPrecisaoFloat(
          contaReceber?.saldoReceber * renegociacaoTitulos.multaPorcentagem,
        )
      : 0;
  juros =
    atraso > 0 && renegociacaoTitulos?.jurosPorcentagem
      ? formatPrecisaoFloat(
          contaReceber?.saldoReceber *
            renegociacaoTitulos.jurosPorcentagem *
            atraso,
        )
      : 0;
  return multa + juros + subtotal;
}

export function calculaMultaBaixa(
  contaReceber,
  renegociacaoTitulos,
  dataPagamento = new Date(),
) {
  const atraso = getAtrasoDias(contaReceber?.dataVencimento, dataPagamento);
  if (atraso <= renegociacaoTitulos?.carencia) {
    return 0;
  }
  return formatPrecisaoFloat(
    contaReceber?.saldoReceber * renegociacaoTitulos.multaPorcentagem,
  );
}

export function calculaJurosBaixa(
  contaReceber,
  renegociacaoTitulos,
  dataPagamento = new Date(),
) {
  const atraso = getAtrasoDias(contaReceber?.dataVencimento, dataPagamento);
  if (atraso <= renegociacaoTitulos?.carencia) {
    return 0;
  }
  return formatPrecisaoFloat(
    contaReceber?.saldoReceber * renegociacaoTitulos.jurosPorcentagem * atraso,
  );
}

export function calculaTotalAReceber(
  listaContasReceber,
  dataPagamento,
  jurosMultaEmpresas = [],
) {
  let [multa, juros, subtotal] = [0, 0, 0];
  for (const contaPagar of listaContasReceber) {
    const jurosMulta = jurosMultaDoTitulo(jurosMultaEmpresas, contaPagar);
    const atraso = getAtrasoDias(contaPagar?.dataVencimento, dataPagamento);
    subtotal += contaPagar?.saldoReceber ?? 0;
    if (atraso > jurosMulta.carencia) {
      multa +=
        atraso > 0 && jurosMulta.multaPorcentagem
          ? formatPrecisaoFloat(
              contaPagar?.saldoReceber * jurosMulta.multaPorcentagem,
            )
          : 0;
      juros +=
        atraso > 0 && jurosMulta.jurosPorcentagem
          ? formatPrecisaoFloat(
              contaPagar?.saldoReceber * jurosMulta.jurosPorcentagem * atraso,
            )
          : 0;
    }
  }
  const receber = subtotal + multa + juros;
  return { multa, juros, subtotal, receber };
}

export const montaListaContasABaixar = (
  listaContasReceber,
  meioPagamento,
  baixaLote,
  jurosMultaEmpresas = [],
  renegociacao = false,
) => {
  const contasReceber = listaContasReceber.map((conta) => {
    const total = calculaMultaJurosBaixa(
      conta,
      jurosMultaDoTitulo(jurosMultaEmpresas, conta),
      baixaLote?.dataPagamento ?? new Date().toISOString(),
    );
    const pagamento = {
      contasReceberId: conta?.id,
      dataPagamento: baixaLote?.dataPagamento ?? new Date().toISOString(),
      bancoCaixaId: baixaLote?.bancoCaixaId ?? meioPagamento?.bancoCaixaId,
      pagadorId: conta?.pagadorId,
      meioPagamento,
      tipoBaixa: renegociacao ? "BAIXA_RENEGOCIACAO" : "BAIXA_NORMAL",
      meioPagamentoId: meioPagamento.id,
      saldoDevedor: total,
      valor: total,
    };
    return {
      ...conta,
      status: "BAIXADO",
      pagamentos: [...conta.pagamentos, pagamento],
    };
  });
  return contasReceber;
};
